// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b52f9db0","464":"5600cafc","719":"e96d80f1","787":"5128b469"}[chunkId] + ".chunk.js";
};